import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { auth } from '../services/firebase';
import { sendPasswordResetEmail } from 'firebase/auth';
import '../assets/css/auth.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    
    setError('');
    setSuccess(false);
    setLoading(true);

    try {
      await sendPasswordResetEmail(auth, email);
      setSuccess(true);
    } catch (error) {
      console.error('Password reset error:', error);
      setError('Fehler beim Senden der E-Mail. Bitte überprüfen Sie die E-Mail-Adresse.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <div className="auth-logo-placeholder">
              <img src="assets/images/Logo3-01.png" alt="Hof-Portal Logo" />
            </div>
            <h1>Passwort zurücksetzen</h1>
          </div>

          <div className="auth-methods">
            {success ? (
              <div className="success-message">
                <i className="fas fa-check-circle success-icon"></i>
                <h2>E-Mail gesendet</h2>
                <p>Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet.</p>
                <Link to="/login" className="auth-button primary">
                  Zurück zum Login
                </Link>
              </div>
            ) : (
              <form className="auth-form" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label htmlFor="email">E-Mail</label>
                  <input 
                    type="email" 
                    id="email" 
                    name="email" 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required 
                    placeholder="Ihre E-Mail-Adresse"
                  />
                </div>

                {error && (
                  <div className="error-message">
                    <i className="fas fa-exclamation-circle"></i>
                    {error}
                  </div>
                )}

                <button 
                  type="submit" 
                  className="auth-button primary"
                  disabled={loading}
                >
                  {loading ? 'Wird gesendet...' : 'Link zum Zurücksetzen senden'}
                </button>

                <div className="auth-footer">
                  <p>Zurück zum <Link to="/login">Login</Link></p>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword; 